<!--能耗计算对象 右键属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? '修改-能耗批量统计' : '创建-能耗批量统计'" :has-form="true" class="time-event-dialog-modal" top="15%" width="30%"
      @close="close" @confirm="handleConfirm">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <gs-form :model="form" label-width="50px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="name" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="description">
              </el-input>
            </gs-form-item>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="数据选取" name="second">
          <div class="border-main">
            <gs-form :model="form" label-width="90px" label-position="left" gap="small">


              <gs-form-item label="时间间隔" prop="target" class="form-item-radio">
                <gs-select v-model="form.cron" size="mini">
                  <gs-option v-for="item in timeArray" :key="item.value" :label="item.label" :value="item.value">
                  </gs-option>
                </gs-select>
              </gs-form-item>
              <gs-form-item label="计算方法" prop="target" class="form-item-radio">
                <gs-select v-model="form.method" size="mini">
                  <gs-option v-for="item in methodArray" :key="item.value" :label="item.label" :value="item.value">
                  </gs-option>
                </gs-select>
              </gs-form-item>
              <fieldset>
                <legend>选择点位</legend>
                <gs-form-item label="填写" prop="target" class="form-item-radio" label-width="50px">
                  <gs-input v-model="form.batch" placeholder="输入批量计算的点位名称"></gs-input>
                </gs-form-item>
                <gs-form-item label="选择" prop="fromObject" label-width="50px">
                  <gs-input v-model="form.showFromObject" style="width:84%" :disabled="true" placeholder="选择要计算的点位名称" />
                  <gs-button @click="addObject('fromObject')">...</gs-button>
                </gs-form-item>
              </fieldset>
              <fieldset>
                <legend>结果</legend>
                <gs-form-item label="对象" prop="toObject" label-width="50px">
                  <gs-input v-model="form.showToObject" style="width:84%" :disabled="true" placeholder="选择输出的点位" />
                  <gs-button @click="addObject('toObject')">...</gs-button>
                </gs-form-item>
              </fieldset>
            </gs-form>
          </div>
        </gs-tab-pane>
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <!--   <gs-button type="primary" size="mini">帮 助</gs-button> -->
      </span>
    </gs-modal>

    <gs-modal v-model="visibleAdds" :title="'添加'" class="alarmReceiver-select" @close="closeAdd"
      @confirm="handleConfirmAdds">
      <div class="treeList">
        <gs-tree @node-click="treeClick" v-if="visibleAdds" ref="tree" :data="dataList" :props="props"
          :disable-node="true" :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
      </div>
    </gs-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
export default {
  components: {

  },
  data() {
    return {
      nodeId: "",
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      showFromObject: "",
      showToObject: '',
      loading: false,
      activeName: 'first',
      name: '',
      description: '',
      form: {
        showFromObject: '',
        showToObject: '',
        logInterval_value: '',
        fromObject: {},
        toObject: {},
        tableId: '',
        batch: '', // 点位的名称
        cron: '',
        method: '',
        jobName: "",
        jobGroupName: "",
        nodeId: [],
        keyPrefix: [],
        result: ''
      },
      isEdit: false,
      visibleAdds: false,
      dataList: [],
      timeArray: [
        {
          value: '0/10 * * * * ?',
          label: '10S'
        },
        {
          value: '0/20 * * * * ?',
          label: '20S'
        }, {
          value: '0/30 * * * * ?',
          label: '30S'
        },
      ],
      methodArray: [
        {
          value: 'sum',
          label: '求和'
        }, {
          value: 'average',
          label: '求平均值'
        }, {
          value: 'max',
          label: '求极大值'
        }, {
          value: 'min',
          label: '求极小值'
        }, {
          value: 'median',
          label: '求中位数'
        },
      ]
    }
  },
  computed: {
    ...mapState({
      visible: 'energyStatisticsShow',
      nodeData: 'nodeTree',
      objectData: 'objectInfo'
    })
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData
    },
    visible() {
      if (this.visible) {
        this.isEdit = true
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        this.activeName = 'first'
        if (JSON.stringify(this.objectData) !== '{}' && this.objectData.type === 'BatchEnergyMetrics') {
          // this.form = this.objectData.attribute ? this.objectData.attribute : {}
          this.form = this.objectData.attribute ? this.objectData.attribute : {}
          this.description = this.objectData.description
          this.name = this.objectData.name
        } else {
          this.isEdit = false
          this.form = {
            showFromObject: '',
            showToObject: '',
            logInterval_value: '',
            tableId: '',
            batch: '', // 点位的名称
            cron: '',
            method: '',
            jobName: "",
            jobGroupName: "",
            nodeId: [],
            keyPrefix: [],
            result: ''
          }
          this.description = ''
          this.name = ''
          this.showFromObject = ""
          this.showToObject = ""
        }
      } else {
        this.isEdit = false
        this.form = {
          showFromObject: '',
          showToObject: '',
          logInterval_value: '',
          tableId: '',
          batch: '', // 点位的名称
          cron: '',
          method: '',
          jobName: "",
          jobGroupName: "",
          nodeId: [],
          keyPrefix: [],
          result: ''
        }
        this.description = ''
        this.name = ''
        this.showFromObject = ""
        this.showToObject = ""
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'ENERGY_STATISTICS_HIDE'
    }),
    //主
    beforeClose() {
      this.close()
    },
    handleConfirm() {
      let _this = this
      if (this.name != "") {
        let obj = {
          name: this.name,
          type: "BatchEnergyMetrics",
          description: this.description,
          parentId: this.nodeData.id,
          attribute: {
            showFromObject: this.form.showFromObject,
            showToObject: this.form.showToObject,
            jobName: 6,
            jobGroupName: this.nodeData.name,
            tableId: this.nodeData.id,
            batch: this.form.batch,
            nodeId: this.form.nodeId,
            keyPrefix: this.form.keyPrefix,
            cron: this.form.cron,
            method: this.form.method,
            resultId: this.form.result
          }
        }
        if (_this.isEdit) {
          service.renamePoint(obj).then(res => {
            _this.close()
            this.$Message.success("修改成功！")
          })
        } else {
          service.newAddPoint(obj).then(res => {
            _this.close()
            this.$Message.success("创建成功！")
          })
        }
      } else {
        this.$Message.info("请填写完整信息！")
      }

    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    addObject(input) {
      let _this = this
      _this.dataList = []
      this.visibleAdds = true
      let treeArr = []
      // 树状目录的组装
      if (this.nodeData.type == "server" || this.nodeData.type == "project") {
        switch (input) {
          case 'fromObject':
            _this.addTitle = '监控点位'
            setTimeout(() => {
              //_this.dataList = _this.$store.state.nodeAll
              service.getAllTree().then(res => {
                _this.dataList = res
              })
            }, 1000)
            break
          case 'toObject':
            _this.addTitle = '接收点位'
            setTimeout(() => {
              //_this.dataList = _this.$store.state.nodeAll
              service.getAllTree().then(res => {
                _this.dataList = res
              })
            }, 1000)
            break
          default:
            break
        }
      }
      else if (this.nodeData.type == "logicalGroup") {
        service.getTree('', this.nodeData.id).then(res => {
          res[0].children.forEach(item => {
            service.getTree('Point', item.id).then(restree => {
              item.children = restree[0].children
            })
          })
          switch (input) {
            case 'fromObject':
              _this.addTitle = '监控点位'
              setTimeout(() => {
                _this.dataList = res
              }, 3000)

              break
            case 'toObject':
              _this.addTitle = '接收点位'
              setTimeout(() => {
                _this.dataList = res
              }, 3000)
              break
            default:
              break
          }

        })
      } else {
        switch (input) {
          case 'fromObject':
            this.addTitle = '监控点位'
            service.getTree('Point', this.nodeData.id).then(res => {
              if (res[0] !== null) {
                this.dataList = res
              }
              this.dataList = res
            })
            this.dataList = treeArr
            break
          case 'toObject':
            this.addTitle = '接收点位'
            service.getTree('Point', this.nodeData.id).then(res => {
              if (res[0] !== null) {
                this.dataList = res
              }
            })
            break
          default:
            break
        }
      }

    },
    handleConfirmAdds() {
      let _this = this
      let array = this.$refs.tree.getCheckedNodes(true)
      console.log(array)
      if (this.addTitle == "监控点位") {
        array.forEach(item => {
          _this.form.showFromObject = _this.form.showFromObject + " , " + item.data.name
          if (item.data.keyPrefix == "" || item.data.keyPrefix == null) {
            _this.form.nodeId.push(item.data.id)
          } else {
            _this.form.keyPrefix.push(item.data.keyPrefix)

          }
        })
      }
      if (this.addTitle == "接收点位") {
        this.form.showToObject = array[0].data.name
        this.form.result = array[0].data.id
      }
      this.visibleAdds = false
    },
    treeClick(data) {
      data.data.id
    },
    checkEvent(node, isSelect, halfSelect) {
      if (this.addTitle == "接收点位") {
        switch (node.type) {
          case 'value_Analog':
            this.singleChoice(node.id)
            break
          case 'value_Multistate':
            this.singleChoice(node.id)
            break
          case 'value_Binary':
            this.singleChoice(node.id)
            break
          case 'value_String':
            this.singleChoice(node.id)
            break
          case 'BinaryInput':
            this.singleChoice(node.id)
            break
          case 'BinaryOutput':
            this.singleChoice(node.id)
            break
          case 'AnalogInput':
            this.singleChoice(node.id)
            break
          case 'AnalogOutput':
            this.singleChoice(node.id)
            break
          case 'boolWrite':
            this.singleChoice(node.id)
            break

          case 'BinaryInputW':
            this.singleChoice(node.id)
            break
          case 'BinaryInputR':
            this.singleChoice(node.id)
            break
          case 'BinaryOutputW':
            this.singleChoice(node.id)
            break
          case 'BinaryOutputR':
            this.singleChoice(node.id)
            break
          case 'AnalogInputW':
            this.singleChoice(node.id)
            break
          case 'AnalogInputR':
            this.singleChoice(node.id)
            break
          case 'AnalogOutputW':
            this.singleChoice(node.id)
            break
          case 'AnalogOutputR':
            this.singleChoice(node.id)
            break
          case 'DigitalOutputW':
            this.singleChoice(node.id)
            break
          case 'DigitalOutputR':
            this.singleChoice(node.id)
            break
          case 'DigitalInputW':
            this.singleChoice(node.id)
            break
          case 'DigitalInputR':
            this.singleChoice(node.id)
            break
          case 'AnalogW':
            this.singleChoice(node.id)
            break
          case 'IntegerW':
            this.singleChoice(node.id)
            break
          case 'AnalogR':
            this.singleChoice(node.id)
            break
          case 'IntegerR':
            this.singleChoice(node.id)
            break
          case 'BinaryW':
            this.singleChoice(node.id)
            break
          case 'BinaryR':
            this.singleChoice(node.id)
            break
          default:
            this.$Message.error('此节点为目录，无法被选择')
            this.$refs.tree.setChecked(node.id, false)
            break
        }
      }

    },
    // 单选操作
    singleChoice(id) {
      let leafCheckArr = this.$refs.tree.getCheckedKeys()
      if (leafCheckArr.length > 1) {
        leafCheckArr.forEach(item => {
          if (item != id) {
            this.$refs.tree.setChecked(item, false)
          }
        })
      }
    },
    closeAdd() {

    },
  }
}
</script>
<style>
/* .gs-form-item {
  margin-bottom: 0px !important;
} */
</style>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/timeChart/energyStatiscs.vue